var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SlidingPagination',_vm._g(_vm._b({staticClass:"ts-pagination",attrs:{"page-component":"the-source-pagination-2-page"}},'SlidingPagination',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }